import { defineMessages } from 'react-intl';

export default defineMessages({
  // olf mfa promote page
  promoteMfaHeader: {
    id: 'mfa.promote.header',
    defaultMessage: 'Enable two-step verification',
    description: 'Header to promote two-step verification',
  },
  promoteMfaMessageBody: {
    id: 'mfa.promote.message',
    defaultMessage:
      'To keep your account secure, two-step verification adds another step when logging in with your username and password.',
    description: 'Main message to promote two-step verification',
  },
  promoteMfaLearnMore: {
    id: 'mfa.promote.learn',
    defaultMessage: 'Learn more about two-step verification',
    description: 'Text on link to learn more about two-step verification',
  },
  promoteMfaContinue: {
    id: 'mfa.promote.continue',
    defaultMessage: 'Enable two-step verification',
    description: 'Button text for continue to setup two-step verification',
  },
  promoteMfaDismiss: {
    id: 'mfa.promote.dismiss',
    defaultMessage: 'Continue without two-step verification',
    description: 'Button text for continuing without setting up two-step verification',
  },
  // new 'security review' page with mfa and passkeys
  promoteMfaPasskeysHeader: {
    id: 'mfa-passkeys.promote.header',
    defaultMessage: 'Security review',
    description: 'Header to promote two-step verification and passkeys',
  },
  promotePasskeysMessageBody: {
    id: 'passkeys.promote.message',
    defaultMessage: 'A passkey allows you to log in securely without additional steps.',
    description: 'Main message to promote passkeys',
  },
  promotePasskeysContinue: {
    id: 'passkeys.promote.continue',
    defaultMessage: 'Create a passkey',
    description: 'Button text for continue to setup passkeys',
  },
  promotePasskeysLearnMore: {
    id: 'passkeys.promote.learn',
    defaultMessage: 'Learn more about passkeys',
    description: 'Text on link to learn more about passkeys',
  },
});
